/*
  KAN-764: photo viewer for the At-Home page.

  Any button with [data-zoom-open] opens a full-screen view of the images
  inside its nearest [data-zoom-scope]. Images opt in with data-zoom-src
  (the larger rendition to show). Only images that are currently laid out
  are included, so a tier gallery hidden with display:none never leaks into
  another tier's viewer. The viewer starts on the image with class "active",
  or on the first one.

  Loaded by more than one section, so the whole file is guarded to run once.
*/
(() => {
  if (window.olfAtHomeLightbox) return;
  window.olfAtHomeLightbox = true;

  let dialog = null;
  let imgEl = null;
  let counterEl = null;
  let prevBtn = null;
  let nextBtn = null;
  let slides = [];
  let index = 0;
  let opener = null;
  let touchStartX = null;

  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'ah-lightbox';
    dialog.setAttribute('aria-label', 'Photo viewer');
    dialog.innerHTML = `
      <div class="ah-lightbox__stage">
        <img class="ah-lightbox__img" alt="">
      </div>
      <button type="button" class="ah-lightbox__close" aria-label="Close photo viewer">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
      <button type="button" class="ah-lightbox__nav ah-lightbox__nav--prev" aria-label="Previous photo">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <button type="button" class="ah-lightbox__nav ah-lightbox__nav--next" aria-label="Next photo">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
      <div class="ah-lightbox__counter" aria-live="polite"></div>
    `;
    document.body.appendChild(dialog);

    imgEl = dialog.querySelector('.ah-lightbox__img');
    counterEl = dialog.querySelector('.ah-lightbox__counter');
    prevBtn = dialog.querySelector('.ah-lightbox__nav--prev');
    nextBtn = dialog.querySelector('.ah-lightbox__nav--next');

    dialog.querySelector('.ah-lightbox__close').addEventListener('click', () => dialog.close());
    prevBtn.addEventListener('click', () => show(index - 1));
    nextBtn.addEventListener('click', () => show(index + 1));

    // A click on the dark area around the photo closes the viewer; a click on
    // the photo itself or on a control does not.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.classList.contains('ah-lightbox__stage')) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });

    dialog.addEventListener('touchstart', (event) => {
      touchStartX = event.touches.length === 1 ? event.touches[0].clientX : null;
    }, { passive: true });
    dialog.addEventListener('touchend', (event) => {
      if (touchStartX === null || slides.length < 2) return;
      const dx = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ah-lightbox-open');
      if (opener) opener.focus({ preventScroll: true });
      opener = null;
    });
  };

  const show = (next) => {
    if (!slides.length) return;
    index = (next + slides.length) % slides.length;
    const slide = slides[index];
    imgEl.src = slide.src;
    imgEl.alt = slide.alt;
    const multiple = slides.length > 1;
    prevBtn.hidden = !multiple;
    nextBtn.hidden = !multiple;
    counterEl.hidden = !multiple;
    counterEl.textContent = multiple ? `${index + 1} / ${slides.length}` : '';
  };

  const open = (button) => {
    const scope = button.closest('[data-zoom-scope]');
    if (!scope) return;
    const images = Array.from(scope.querySelectorAll('img[data-zoom-src]'))
      .filter((img) => img.getClientRects().length > 0);
    if (!images.length) return;

    if (!dialog) build();
    slides = images.map((img) => ({ src: img.dataset.zoomSrc, alt: img.alt || '' }));
    const start = Math.max(0, images.findIndex((img) => img.classList.contains('active')));
    opener = button;
    show(start);
    document.documentElement.classList.add('ah-lightbox-open');
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-zoom-open]');
    if (!button) return;
    event.preventDefault();
    open(button);
  });
})();
